import React, { useState } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
} from '@mui/material';
import Label from '../utils/Label';
import { formatDateMX } from '../../helpers/hours';
import {
    typeColor,
    columnStyles,
    typeAction,
    columnTitles,
} from '../utils/lists';

// Render a status label with corresponding color based on status value
const renderStatusLabel = status => {
    const colorMap = {
        Verde: 'success',
        Amarillo: 'warning',
        Rojo: 'error',
    };
    const colorText = typeColor[status] || '-';
    return (
        <Label color={colorMap[colorText]} variant="ghost">
            {colorText}
        </Label>
    );
};

export const ResultsTable = ({ prospecting }) => {
    const [page, setPage] = useState(0);
    const rowsPerPage = 6;

    // Sort prospecting entries by most recent 'first_date'
    const sortedProspects = [...prospecting].sort(
        (a, b) => new Date(b.first_date) - new Date(a.first_date)
    );

    // Page change handler
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Calculate the entries to display for the current page
    const displayedProspects = sortedProspects.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <Box sx={{ padding: 2 }}>
            <Typography variant="h5" gutterBottom>
                Tabla de resultados
            </Typography>

            <TableContainer component={Paper}>
                <Table aria-label="prospecting table">
                    <TableHead>
                        <TableRow>
                            {[
                                'accion',
                                'contacto',
                                'fecha1',
                                'cita',
                                'fecha2',
                                'lead',
                                'fecha3',
                                'cotizacion',
                                'fecha4',
                                'cierre',
                                'fecha5',
                            ].map(key => (
                                <TableCell
                                    align="center"
                                    sx={{
                                        backgroundColor:
                                            columnStyles[key].header,
                                        color: columnStyles[key].color,
                                        fontWeight: 'bold',
                                    }}
                                    key={key}
                                >
                                    {columnTitles[key] ||
                                        key.charAt(0).toUpperCase() +
                                            key.slice(1)}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedProspects.map((prospect, index) => (
                            <TableRow key={index}>
                                <TableCell align="center">
                                    {typeAction[prospect.action] || '-'}
                                </TableCell>
                                <TableCell align="center">
                                    {renderStatusLabel(prospect.contact)}
                                </TableCell>
                                <TableCell align="center">
                                    {formatDateMX(prospect.first_date)}
                                </TableCell>
                                <TableCell align="center">
                                    {renderStatusLabel(prospect.appointment)}
                                </TableCell>
                                <TableCell align="center">
                                    {formatDateMX(prospect.second_date)}
                                </TableCell>
                                <TableCell align="center">
                                    {renderStatusLabel(prospect.lead)}
                                </TableCell>
                                <TableCell align="center">
                                    {formatDateMX(prospect.third_date)}
                                </TableCell>
                                <TableCell align="center">
                                    {renderStatusLabel(prospect.quotation)}
                                </TableCell>
                                <TableCell align="center">
                                    {formatDateMX(prospect.fourth_date)}
                                </TableCell>
                                <TableCell align="center">
                                    {renderStatusLabel(prospect.closing)}
                                </TableCell>
                                <TableCell align="center">
                                    {formatDateMX(prospect.fifth_date)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Table pagination */}
            <TablePagination
                component="div"
                count={prospecting.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPageOptions={[6]}
            />
        </Box>
    );
};
